<template>
  <div class="bg-light">
    <nav-component></nav-component>
    <div>
      <div class="bg-image mt-5">
        <div class="banner mask"></div>
      </div>
    </div>
    <div class="container">
      <div class="row py-5">
        <div class="col-lg-12 text-center">
          <span class="h1 font-weight-bold text-uppercase"
            >Нашите Најбарани производи</span
          >
        </div>
        <div v-for="product in best" :key="product.index" class="col-lg-4">
          <div
            class="col-lg-12 mx-auto my-5 bg-white rounded border border-dark text-center p-3"
          >
            <img
              class="img-fluid rounded"
              :src="product.images[0]"
              :alt="product.name"
            />
            <h4 class="text-secondary font-weight-bold">{{ product.name }}</h4>
            <div class="row mx-auto">
              <div class="col-lg-12 my-1 mx-auto">
                <a
                  :href="getLink(product['.key'])"
                  class="btn btn-outline-primary rounded"
                  >Повеќе</a
                >
              </div>
              <div v-show="product.quantity > 0" class="col-lg-12 my-1 mx-auto">
                <button
                  @click="addToCart(product)"
                  class="btn btn-primary rounded"
                  :class="{ disabled: product.quantity <= 0 }"
                >
                  Додади во <i class="fas fa-shopping-bag"></i>
                </button>
              </div>
              <div
                v-show="product.quantity <= 0"
                class="col-lg-12 my-1 mx-auto"
              >
                <span class="btn btn-primary rounded disabled"
                  >Распродадено</span
                >
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <footer-component></footer-component>
  </div>
</template>

<script>
import { productsRef } from "../firebase";
import Nav from "../components/Navbar.vue";
import Footer from "../components/Footer.vue";
export default {
  data() {
    return { products: [] };
  },
  firebase: {
    products: productsRef,
  },
  methods: {
    getLink(id) {
      return "/details/" + id;
    },
    addToCart(item) {
      this.$store.commit("addToCart", item);
    },
  },
  computed: {
    best() {
      let bestProducts = [];
      bestProducts = this.products;
      bestProducts
        .sort((a, b) => {
          return a.sold - b.sold;
        })
        .reverse();
      bestProducts = bestProducts.slice(0, 6);
      return bestProducts;
    },
  },
  components: {
    "nav-component": Nav,
    "footer-component": Footer,
  },
};
</script>
<style scoped>
.bg-image {
  background: url("../assets/images/homepage-background.png") scroll no-repeat;
  background-size: cover;
  -o-background-size: cover;
  -moz-background-size: cover;
  -webkit-background-size: cover;
}

.mask {
  background-color: rgba(0, 0, 0, 0.3);
}

.banner {
  height: 100vh;
  display: flex;
  align-items: center;
}
</style>
